import SmsCodeInput from "./SmsCodeInput";

export default SmsCodeInput;